export function buildString() {
  if (process.env.REACT_APP_BUILD_COMMIT) {
    return `${process.env.REACT_APP_BUILD_COMMIT} - ${process.env.REACT_APP_BUILD_DATE}`;
  }

  return "Development";
}
